"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MallWebSwiper = void 0;
var swiper_1 = require("swiper");
var MallWebSwiper = /** @class */ (function () {
    function MallWebSwiper() {
    }
    MallWebSwiper.setup = function () {
        var containerSelector = '.swiper-container';
        new swiper_1.Swiper(containerSelector, {
            autoplay: true,
            spaceBetween: 20,
            slidesPerView: 1,
            slidesPerGroup: 1,
            roundLengths: true,
            modules: [swiper_1.Navigation, swiper_1.Pagination],
            breakpoints: {
                576: {
                    // sm
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    speed: 500,
                },
                768: {
                    // md
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    speed: 750,
                },
                992: {
                    // lg
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    speed: 1000,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
        // To show the swiper after setup
        $(containerSelector).css('visibility', 'visible');
    };
    return MallWebSwiper;
}());
exports.MallWebSwiper = MallWebSwiper;
